import { create } from 'zustand'

interface ICookieStore {
  updateClient: {
    accessToken: string
    refreshToken: string
  }
  setUpdateClient: (accessToken: string, refreshToken: string) => void
}

export const useCookieStore = create<ICookieStore>((set) => ({
  updateClient: {
    accessToken: '',
    refreshToken: '',
  },
  setUpdateClient: (accessToken: string, refreshToken: string) =>
    set({ updateClient: { accessToken, refreshToken } }),
}))
